import React from 'react';
import { Grid, Typography, Box } from '@material-ui/core';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import UploadCsv from '../uploadCsv';
import UploadContactRow from '../uploadContactRow';


const useStyles = makeStyles(({
  // root: {
  //   '&:hover': {
  //     backgroundColor: 'transparent',
  //   },
  // },
  // icon: {
  //   backgroundColor: '#1D4659',
  //   // ... #somecss
  // },
  // checkedIcon: {
  //   backgroundColor: '#1D4659',
  //   // ... #somecss
  // }
}))


const AddGrup1 = ({ contact }) => {
  const classes = useStyles();
  const [value, setValue] = React.useState('');

  const handleRadioChange = (event) => {
    setValue(event.target.value);
  };
  
  const handleContactArray = (data) => {
    contact(data)
  }

  const customRadio =
    <Radio
      className={classes.root}
      disableRipple
      color="default"
      size="small"
      // checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      // icon={<span className={classes.icon} />}
      // {...props}
    />;

    return (
    <Grid container spacing={3} style={{justifyContent: "center"}}>
      <Grid item xs={12} md={12}>
        <Typography className="font-size-14 mb-5 bold">
          Tambahkan Kontak
        </Typography>
        <Box className="d-flex mb-5 w-100" style={{ justifyContent: 'space-between' }}>
          <div style={{justifyContent:'space-between'}}>
            <FormControl component="fieldset">
              <RadioGroup row name="position" value={value} onChange={handleRadioChange}>
                <FormControlLabel
                  value="csv"
                  control={customRadio}
                  label={<span style={{ fontSize: '0.9rem', marginRight:'10px' }}>Upload .csv</span>}
                />
                <FormControlLabel
                  value="manual"
                  control={customRadio}
                  label={<span style={{ fontSize: '0.9rem' }}>Tambahkan Secara Manual</span>}
                />
              </RadioGroup>
            </FormControl>
          </div>
          <span className="font-size-10 mt-15">Maksimum 200 kontak</span>
        </Box>
      </Grid>
      {
        value === 'csv' &&
        <Grid item xs={12} md={12} style={{border: "3px solid #dadada", height:'225px'}}>
          <UploadCsv csvArray={handleContactArray}/>
        </Grid>
      }
      {
        value === 'manual' &&
        <Grid item xs={12} md={12}>
          <UploadContactRow contactArray={handleContactArray}/>
        </Grid>
      }
  </Grid>
  );
}

export default AddGrup1
